export default __webpack_public_path__ + "80188897f1627fa6937ecfe8fbe5adce.svg";